export enum LotMediaType {
    IMAGE = "IMAGE",
    YOUTUBE = "YOUTUBE"
}